import dynamic from 'next/dynamic';
import { useState } from 'react';

import useMediaQuery from 'hooks/useMediaQuery';

const Drawer = dynamic(() => import('./Drawer'), { ssr: false });
const DesktopModal = dynamic(() => import('./DesktopModal'), { ssr: false });

const CampaignModal = ({
  campaigns = [],
  onClose = () => {},
  onCtaClick = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const { isLg } = useMediaQuery();

  if (!isOpen || !campaigns.length) return null;

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  // Render only the surface for the current breakpoint. Mounting both and
  // hiding one with CSS still ran the desktop Modal.Root, whose showModal()
  // put a modal dialog in the top layer and made the mobile Drawer's CTA
  // untappable. Rendering a single surface keeps showModal() off mobile.
  return isLg ? (
    <DesktopModal
      campaigns={campaigns}
      onClose={handleClose}
      onCtaClick={onCtaClick}
    />
  ) : (
    <Drawer
      campaigns={campaigns}
      onClose={handleClose}
      onCtaClick={onCtaClick}
    />
  );
};

export default CampaignModal;
